import { environment } from "../../../environments/environment";

export class Api {
  private static host = environment.url;
  private static cognitoLogin = environment.cognitoLoginUrl;
  private static cognitoMfa = environment.cognitoMfaUrl;
  private static cognitoCodeVerification = environment.cognitoCodeVerification;

  public static login = Api.cognitoLogin;
  public static mfa = Api.cognitoMfa;
  public static codeVerification = Api.cognitoCodeVerification;
  
  public static Auth = Api.host + '/api/Auth';
  public static ServiceType = Api.host + '/api/ServiceTypes';
  public static Genders = Api.host + '/api/Genders';
  public static Schooling = Api.host + '/api/Schooling';
  public static RelativeTypes = Api.host + '/api/RelativeTypes';
  public static MaritalStatuses = Api.host + '/api/MaritalStatuses';
  public static IdentityNumberTypes = Api.host + '/api/IdentityNumberTypes';
  public static TaxNumberTypes = Api.host + '/api/TaxNumberTypes';
  public static SocialNumberTypes = Api.host + '/api/SocialNumberTypes';
  public static ClientDivision = Api.host + '/api/ClientDivisions';
  public static RelativePeople = Api.host + '/api/RelativePeople';
  public static Countries = Api.host + '/api/Countries';
  public static States = Api.host + '/api/States';
  public static Localities = Api.host + '/api/Localities';
  public static Occupations = Api.host + '/api/Occupations';
  public static EmploymentHistoryByPersons = Api.host + '/api/EmploymentHistoryByPersons';
  public static PersonalReferenceByPersons = Api.host + '/api/PersonalReferenceByPersons';
  public static People = Api.host + '/api/People';
  public static SIESPServices = Api.host + '/api/SIESPServices';
  public static Reports = Api.host + '/api/Reports';
}
